import axios from 'axios';
import { PUBLISHING_SERVICE_URL } from '~/config';
import { handleNetworkError, withVersionHeaders } from '../utilities/axiosUtilities';
import { removeIteratorKeyFromState } from '../utilities/browserUtilities';
export function getListing(id) {
  const url = `${PUBLISHING_SERVICE_URL}/publishing/streams/listings/${id}`;
  return axios.get(url, withVersionHeaders('2')).then(response => {
    var _response$data;
    return (_response$data = response === null || response === void 0 ? void 0 : response.data) !== null && _response$data !== void 0 ? _response$data : null;
  }).catch(handleNetworkError);
}
export function upsertListing(listing) {
  const url = `${PUBLISHING_SERVICE_URL}/publishing/streams/listing`;
  const sanitizedListing = removeIteratorKeyFromState(JSON.parse(JSON.stringify(listing)));
  return axios.post(url, sanitizedListing, withVersionHeaders('2')).then(({
    data
  }) => data);
}
export function validateListing(listing) {
  const url = `${PUBLISHING_SERVICE_URL}/publishing/streams/validate/listing`;
  const sanitizedListing = removeIteratorKeyFromState(JSON.parse(JSON.stringify(listing)));
  return axios.post(url, sanitizedListing, withVersionHeaders('2')).then(({
    data
  }) => data).catch(handleNetworkError);
}